export default "__VITE_ASSET__e2dfb6a9__"